<template>
  <transition name="bottom-slide">
    <div class="video-wrapper">
      <div class="video-player" id="videoplayer"></div>
      <div class="video-info">
        <div class="video-title">
          <h3>{{info.title}}</h3>
        </div>
        <ul class="info-list" v-if="headers">
          <li
            v-for="(item, index) in headers"
            v-if="info[item.tag]"
            :key="index"
          >
            <h4>{{item.name}}:</h4>
            <p v-if="item.tag==='description'">{{info[item.tag]}}</p>
            <span v-else>{{info[item.tag]}}</span>
          </li>
        </ul>
      </div>
      <Arrow class="btn-arrow" type="back" @arrowClick="$emit('closePlayer')"></Arrow>
    </div>
  </transition>
</template>

<script>
import Arrow from "./Arrow.vue";

let player = null;

export default {
  props: {
    headers: Array,
    info: {
      type: Object,
      required: true
    },
    behind: Boolean
  },
  components: {
    Arrow
  },
  data() {
    return {};
  },
  mounted() {
    this.setPlayer();
  },
  beforeDestroy() {
    player.destroy();
  },
  methods: {
    setPlayer() {
      const playerHeight = (window.innerWidth / 16) * 9;
      const host = location.hostname === "shadow.caa.edu.cn"
        ? ""
        : "https://shadow.caa.edu.cn";
      const videourl = this.behind ? this.info.behind : this.info.url || this.info.path;
      player = new TcPlayer("videoplayer", {
        mp4: host + videourl,
        autoplay: true,
        height: playerHeight,
        flash: false,
        live: false,
        poster: this.info.preview || "",
        controls: "default",
        x5_type: "h5",
        x5_orientation: 2,
        systemFullscreen: true
      });
    },
    play() {}
  }
};
</script>

<style lang="scss">
@import "../assets/base";
.video-wrapper {
  @include pageset;
  z-index: 20;
  background-image: url("~@/assets/img/bg.jpg");
  background-position: bottom center;
  background-size: auto 100%;

  .video-player {
    position: relative;
    z-index: 200;
  }

  .btn-arrow {
    position: absolute;
    bottom: 1rem;
    margin-left: 1.2rem;
  }
}

.video-info {
  padding-top: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;

  .video-title {
    margin-bottom: 1rem;

    @include title-h3(1.125rem);
    h3 {
      margin: 0;
      height: 1.2rem;
      line-height: 1.2;

      &::before,
      &::after {
        height: 1.2rem;
      }

      &::before {
        background-image: url("~@/assets/img/video/title-left.png");
      }

      &::after {
        background-image: url("~@/assets/img/video/title-right.png");
      }
    }
  }

  .info-list {
    height: 35vh;
    margin: 0;
    padding-right: 1.2rem;
    font-size: 0.875rem;
    line-height: 1.8;
    overflow-y: auto;

    li {
      white-space: nowrap;
      overflow: hidden;

      &::before {
        content: "";
        position: relative;
        display: inline-block;
        width: 5px;
        height: 5px;
        top: -2px;
        margin-right: 0.5rem;
        background-color: $primary;
        vertical-align: middle;
      }
      h4 {
        display: inline-block;
        margin: 0;
        margin-right: 0.5rem;
        font-weight: 500;
      }
      p {
        margin: 0;
        line-height: 1.5;
        white-space: normal;
      }
    }
  }
}
</style>
